import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const userStudioApi = createApi({
  reducerPath: "userStudioApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["studioDetail"],
  endpoints: (builder) => ({
    getUserStudios: builder.query({
      query: ({ query }) => ({
        url: endpoint.USER_STUDIOS.USER_STUDIOS + "?query=" + query,
        method: "GET",
        headers: headersBase(),
      }),
    }),
    getUserStudioDetail: builder.query({
      query: (id) => ({
        url: `studios/${id}`,
        method: "GET",
        headers: headersBase(),
      }),
    }),
    addStudioServices: builder.mutation({
      query: (body) => ({
        url: "/studios/associate",
        method: "POST",
        headers: headersType(),
        body: body,
      }),
    }),
    getStudioDetail: builder.query({
      query: (id) => ({
        url: `studios/${id}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["studioDetail"],
    }),
    addRateStudio: builder.mutation({
      query: (rate) => ({
        url: "/studios/rate",
        method: "POST",
        body: rate,
        headers: headersType(),
      }),
      invalidatesTags: ["studioDetail"],
    }),
    unlinkStudio: builder.mutation({
      query: (studioId) => ({
        url: "/studios/unlink",
        method: "POST",
        body: studioId,
        headers: headersType(),
      }),
      invalidatesTags: ["studioDetail"],
    }),
  }),
});

export const {
  useGetUserStudiosQuery,
  useGetUserStudioDetailQuery,
  useAddStudioServicesMutation,
  useGetStudioDetailQuery,
  useAddRateStudioMutation,
  useUnlinkStudioMutation,
} = userStudioApi;
